require('./sidebarMenuService');
require('../../fhApp/currentUser/currentUser');

"use strict";

angular.module('app.mainFrame.sidebarMenu.sidebarMenuController', [
    'app.mainFrame.sidebarMenu.sidebarMenuService',
    'app.currentUser'
])
    .controller('app.mainFrame.sidebarMenu.sidebarMenuController', [
        '$scope', 'app.mainFrame.sidebarMenu.sidebarMenuService', '$state', '$stateParams', 'currentUser',
        function ($scope, sidebarMenu, $state, $stateParams, currentUser) {
            $scope.sidebarMenu = sidebarMenu;
            $scope.currentUser = currentUser;

          $scope.$watch(function() {
             return currentUser.data.access;
          }, function() {
            sidebarMenu.reinit();
          })
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/sidebarMenu/sidebarMenuController.js